import { render, staticRenderFns } from "./pd-add-to-cart.vue?vue&type=template&id=899e22d2&"
import script from "./pd-add-to-cart.vue?vue&type=script&lang=js&"
export * from "./pd-add-to-cart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrimaryButton: require('/opt/build/repo/storefront/components/atoms/Button/PrimaryButton.vue').default,OutlineButton: require('/opt/build/repo/storefront/components/atoms/Button/OutlineButton.vue').default})
